<template>
  <div>
    <div class="conteneur">
      <div class="chart_conteneur">
        <div class="chart">
          <piechart :data="chartData" :options="chartOptions"></piechart>
        </div>
        <div class="chart_text">
          <h2>Mes Compétences</h2>
          <p>
            Je préfere le front-end. Je n'ai pas de problème a effectuer des
            tâches de back-end mais le front-end est là ou j'ai le plus de
            plaisir a faire ce que j'ai a faire. J'ai aussi beaucoup de plaisir
            a effectuer des montages photos ou vidéos. J'aime bien faire du
            design d'interface mais ce n'est pas ma spécialité.
          </p>
        </div>
      </div>

      <h2>Je peut travailler avec tout ça!</h2>
      <div class="connaissances">
        <div
          class="connaissance"
          v-for="connaissance in connaissances"
          :key="connaissance"
        >
          <img :src="connaissance.url" alt="" />
        </div>
      </div>
    </div>
    <div class="bleed footer">
      <div class="conteneur">
        <h2>Vous êtes un employeur?</h2>
        <router-link :to="{ name: 'Contact' }"
          >On devrais Discuter!</router-link
        >
      </div>
    </div>
  </div>
</template>

<script>
import piechart from "../components/piechart.js";
export default {
  components: {
    piechart
  },
  data() {
    return {
      chartOptions: {
        hoverBorderWidth: 20
      },
      chartData: {
        hoverBackgroundColor: "red",
        hoverBorderWidth: 10,
        labels: ["FrontEnd", "BackEnd", "Gestion", "Montage", "Désign"],
        defaultFontSize: "40px",
        datasets: [
          {
            label: "Data One",
            backgroundColor: [
              "#41B883",
              "#E46651",
              "#00D8FF",
              "#B24DAF",
              "#D7D259"
            ],
            data: [30, 20, 10, 25, 15]
          }
        ]
      },
      connaissances: [
        { name: "php", url: require("../assets/logos/php.svg") },
        { name: "js", url: require("../assets/logos/js.svg") },
        { name: "css", url: require("../assets/logos/css.svg") },
        {
          name: "illustrator",
          url: require("../assets/logos/illustrator.svg")
        },
        { name: "wordpress", url: require("../assets/logos/wordpress.svg") },
        { name: "jquery", url: require("../assets/logos/jquery.svg") },
        { name: "sass", url: require("../assets/logos/sass.svg") },
        { name: "photoshop", url: require("../assets/logos/photoshop.svg") },
        { name: "sql", url: require("../assets/logos/sql.svg") },
        { name: "vuejs", url: require("../assets/logos/vuejs.svg") },
        { name: "gsap", url: require("../assets/logos/gsap.svg") },
        {
          name: "aftereffect",
          url: require("../assets/logos/aftereffect.svg")
        },
        { name: "laravel", url: require("../assets/logos/laravel.svg") },
        { name: "html", url: require("../assets/logos/html.svg") },
        { name: "git", url: require("../assets/logos/git.svg") },
        { name: "premiere", url: require("../assets/logos/premiere.svg") },
        { name: "mvc", url: require("../assets/logos/mvc.svg") },
        { name: "typescript", url: require("../assets/logos/typescript.svg") },
        { name: "ajax", url: require("../assets/logos/ajax.svg") },
        { name: "animate", url: require("../assets/logos/animate.svg") }
      ]
    };
  }
};
</script>
